(function ($) {
  $(document).ready(function () {
    // Shop Now Collection Grid

    if ($("#shopify-section-1602186967415").length > 0 || $(".template-collection").length > 0) {

      var grid_cell_class = $("#shopify-section-1602186967415").length > 0 ? "#shopify-section-1602186967415 .list-products .grid__cell" : ".list-products .grid__cell";

      $(grid_cell_class).each(
        function () {
          var $item = $(this);
          var $link = $item.find(".link");
          var link_text = $link.text().trim();

          if (link_text.toLowerCase().includes("pack of")) {
            var item_name = link_text.split("(")[0].trim();
            var pack_text = link_text.match(/\((.*?)\)/)[0];

            $link.html(`${item_name}<span class="item-pack-text">${pack_text}</span>`);
          }
        }
      );
    }

    // Product Title

    if ($(".product__title.h2").length) {
      var $item_title = $(".product__title.h2");
      var item_title = $(".product__title.h2").text().trim();
      
      if (item_title.toLowerCase().includes("pack of")) {
        var item_name = item_title.split("(")[0].trim();
        var pack_text = item_title.match(/\((.*?)\)/)[0];

        $item_title.html(`${item_name}<span class="item-pack-text">${pack_text}</span>`);
      }

    }


    $(".product__title.h2, .link").addClass("active-title");


    // More Payment Options

    if (
      $(".p-nuff-samples").length > 0 &&
      $(`[data-shopify="payment-button"]`).length > 0
    ) {
      
      var check_g_pay = setInterval(function () {
        var has_g_pay = $(".shopify-payment-button__button").length;

        if (has_g_pay) {
          clearInterval(check_g_pay);
          $(".button-buy-now").prop("disabled", false)
        }
      }, 100);
    }

    $(".button-buy-now").on("click tap", function() {
      $(".shopify-payment-button__more-options")[0].click();
    });


    // Blog Page

    if ($(".p-nuff-crunch-blog").length) {

      $(".article a").on("click tap", function(e) {
        e.preventDefault();
      });

      $(".article").on("click tap", function() {
        var $article = $(this);
        var url = $article.find("a").attr("href");

        location = url;
      });

    }

    // Instafeed

    var check_instafeed_counter = 0;
    var check_instafeed = setInterval(function() {
      check_instafeed_counter += 100;

      if ($("#insta-feed").length > 0 && $("#insta-feed h2").text() !== "") {
        clearInterval(check_instafeed);
        
        var title = $("#insta-feed h2").text().trim().replace("Social", `<span class="icon-spark">Social</span>`);
        
        $("#insta-feed h2").html(title);
      } else if (check_instafeed_counter > 10000) {
        clearInterval(check_instafeed);
      }

    }, 100)

    // Discount for Sub Products

    function check_sub(type) {

      $.getJSON("/cart.js", function(data) {
        var cart = data;
        var has_one_time = false;

        cart.items.forEach(item => {
          var has_insurance = item.product_title.toLowerCase().includes("protection");
          var has_sub = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.name ? item.selling_plan_allocation.selling_plan.name.toLowerCase().includes("delivery every") ? true : false : false: false: false;

          if (!has_sub && !has_insurance) {
            has_one_time = true;
          }

        })

        if (type === "checkout") {

          if (!has_one_time) {
            location = "/discount/FREESHIPPING?redirect=/checkout/";
           // location = "/checkout?discount=%20"; remove code
          } else {
            location = "/checkout/";
          }

        }

      });

    }
    
    $(".cart__checkout-button").on("click tap", function(e) {
      e.preventDefault();

      check_sub("checkout");

    });

    // Reset Error

    if ($("#recover-password-section").length > 0 && $(".alert__errors").length > 0) {
      var alert_error = $(".alert__errors").text().trim().toLowerCase();
      var has_account = !alert_error.includes("no account");
      var $recover_password_section = $("#recover-password-section");

      // hide it
      $recover_password_section.attr("hidden", "");

      if (!has_account) {
        var reset_sub_account_html = `
          <p style="text-align: center">Oops! It looks like you haven't set up an account with a username and password yet to access your order history and upcoming shipments (if you have a subscription).</p>
          <p style="text-align: center">No problem.</p>
          <p style="text-align: center">Your information is still safely stored in our system, you just need to create an account to access it.</p>
          <div class="box__button-wrapper button-wrapper">
            <a href="/account/register" class="button button--enforce-min-width button--primary">Set Up Account</a>
          </div>`;

        $recover_password_section.html(reset_sub_account_html);
      }

      // show it
      $recover_password_section.removeAttr("hidden")

    }



    // 15% off
    if ($(".template-product").length > 0 && $(".product__title").text().toLowerCase().includes("pack of 15")) {

      var check_rc_counter = 0;
      var check_rc = setInterval(function() {

        if ($(`label[for*="subsave"] .rc-option__text`).length) {
          var $rc_span =  $(`label[for*="subsave"] .rc-option__text`);
          var rc_span_text = $rc_span.text().replace("10", 15);
          
          $rc_span.text(rc_span_text);
          clearInterval(check_rc);
        } else if (check_rc_counter > 8000) {
          clearInterval(check_rc);
        }
        
        check_rc_counter += 50;

      }, 50);



    }

    // FAQs


    $(".faq__question").on("click tap", function(e) {
      e.preventDefault();
      var style = $(this).next().attr("style") || "none";

      if (style.includes("none")) {
        $(this).addClass("active-question");
      } else {
        $(this).removeClass("active-question");
      }

    });

  });
})(jQuery);
